import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { QuestionService } from '../../data/question.service';

@Component({
  selector: 'app-stepper',
  imports: [CommonModule],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss',
})
export class StepperComponent {
  quests = inject(QuestionService);
}
